import { PrimaryInfo } from './../util';
import { Organization } from "../../models/Organization";

export const getSuggestion = (organization: Organization): PrimaryInfo => {
    return {
        name: organization.name,
        id: organization.id
    };
};
